import { render, staticRenderFns } from "./outAllowCheck.vue?vue&type=template&id=2fead652&scoped=true&"
import script from "./outAllowCheck.vue?vue&type=script&lang=js&"
export * from "./outAllowCheck.vue?vue&type=script&lang=js&"
import style0 from "./outAllowCheck.vue?vue&type=style&index=0&id=2fead652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fead652",
  null
  
)

export default component.exports